import '../../scss/datepicker/index-bs4.scss';
import Datepicker from '../datepicker/Datepicker';
import cs from '../datepicker/i18n/locales/cs';

Object.assign(Datepicker.locales, cs);

export function initialize() {
    document.addEventListener('focus', function(event) {
        let target = event.target;

        if (
            typeof target.hasAttribute === 'function' &&
            target.hasAttribute('data-datepicker') &&
            target.classList.contains('datepicker-input') === false
        ) {
            console.log('def');
            new Datepicker(target, {
                language: target.dataset.datepicker
            }).show();
        }
    }, true);
}

